import styled from '@emotion/styled';

import { endDirection } from 'app/styles/selectors/markup';
import breakpoints from 'app/styles/constants/breakpoints';

const { widthSmallExtended, widthMediumExtended } = breakpoints;

const S = {};

S.Benefit = styled.li`
  label: Benefit;

  align-items: flex-start;
  color: ${props =>
    props.isActive ? 'var(--colors-scarpa-flow)' : 'var(--colors-silver)'};
  display: ${({ isVisibleOnMobile }) => (isVisibleOnMobile ? 'flex' : 'none')};

  @media (${widthSmallExtended}) {
    display: flex;
  }

  @media (${widthSmallExtended}) {
    display: ${({ isReferenceBenefit }) =>
      isReferenceBenefit ? 'none' : 'flex'};
  }

  @media (${widthMediumExtended}) {
    display: ${({ isVisibleOnDesktop }) =>
      isVisibleOnDesktop ? 'flex' : 'none'};
  }
`;

S.Benefit.Icon = styled.svg`
  label: Icon;

  display: flex;
  flex: 0 0 1.25rem;
  margin-${endDirection}: 0.375rem;
`;

S.Benefit.Crown = styled(S.Benefit.Icon)`
  label: Crown;

  fill: var(--colors-honey-gold-base);
`;

S.Benefit.CheckMark = styled(S.Benefit.Icon)`
  label: CheckMark;

  fill: var(--colors-honey-gold-base);
`;

S.Benefit.Cross = styled(S.Benefit.Icon)`
  label: Cross;

  fill: var(--colors-silver);
`;

S.Benefit.Title = styled.p`
  label: Title;

  padding-top: 0.0625rem;
`;

S.Benefit.Title.Placeholder = styled.span`
  label: Placeholder;

  font-weight: 900;
  font-style: italic;
`;

S.Benefit.Title.PrevSubscription = styled.span`
  label: PrevSubscription;

  text-transform: uppercase;
`;

export default S;
